const storageKey = 'kg-web-activity-visitor';
const supportedTypes = new Set(['INVITE_FRIEND_V2', 'FRIEND_WHEEL']);
const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
let memoryDeviceNo = '';

// 使用随机浏览器标识统计访问，不读取硬件、IP或设备指纹。
export function activityVisitorDeviceNo(storage = localStorage, crypto = globalThis.crypto) {
  let saved = '';
  try { saved = storage.getItem(storageKey); } catch (_) {}
  if (typeof saved === 'string' && uuidPattern.test(saved)) return saved;
  if (!memoryDeviceNo) {
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('');
    memoryDeviceNo = `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }
  try { storage.setItem(storageKey, memoryDeviceNo); } catch (_) {}
  return memoryDeviceNo;
}

// 同一页面实例和身份只上报一次；不因统计失败自动重试而重复计数。
export function createActivityVisitReporter(recordVisit, getIdentity, getDeviceNo = activityVisitorDeviceNo) {
  const reported = new Set();
  return async (activity) => {
    if (!supportedTypes.has(activity?.activityType) || !activity?.id) return false;
    const key = `${activity.id}:${getIdentity() || 'guest'}`;
    if (reported.has(key)) return false;
    reported.add(key);
    try {
      await recordVisit(activity.id, { deviceNo: getDeviceNo() });
      return true;
    } catch (_) {
      console.warn('活动访问记录未保存');
      return false;
    }
  };
}
